import { GlobalProperty } from '../../constants';
import { Helper } from '../Helper';
export class CommonStorageHelper extends Helper {
    constructor() {
        super(...arguments);
        this.needsGlobal = true;
        this.needsGlobalOut = true;
    }
    emitGlobal(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitPushInt(node, GlobalProperty.CommonStorageSerialized);
        sb.emitOp(node, 'OVER');
        sb.emitPushInt(node, GlobalProperty.CommonStorage);
        sb.emitPushBuffer(node, Buffer.alloc(0, 0));
        sb.emitHelper(node, options, sb.helpers.getStorageBase);
        sb.emitHelper(node, options, sb.helpers.handleUndefinedStorage({
            handleUndefined: () => {
                sb.emitOp(node, 'NEWMAP');
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Runtime.Serialize');
            },
            handleDefined: () => {
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Runtime.Deserialize');
                sb.emitOp(node, 'SWAP');
            },
        }));
        sb.emitPushInt(node, 4);
        sb.emitOp(node, 'XTUCK');
        sb.emitOp(node, 'DROP');
        sb.emitOp(node, 'SETITEM');
        sb.emitOp(node, 'SETITEM');
    }
    emitGlobalOut(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, GlobalProperty.CommonStorageSerialized);
        sb.emitOp(node, 'PICKITEM');
        sb.emitOp(node, 'SWAP');
        sb.emitPushInt(node, GlobalProperty.CommonStorage);
        sb.emitOp(node, 'PICKITEM');
        sb.emitSysCall(node, 'Neo.Runtime.Serialize');
        sb.emitOp(node, 'TUCK');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'EQUAL');
            },
            whenTrue: () => {
                sb.emitOp(node, 'DROP');
            },
            whenFalse: () => {
                sb.emitSysCall(node, 'Neo.Runtime.GetTrigger');
                sb.emitPushInt(node, 0x10);
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitOp(node, 'NUMEQUAL');
                    },
                    whenTrue: () => {
                        sb.emitPushBuffer(node, Buffer.alloc(0, 0));
                        sb.emitSysCall(node, 'Neo.Storage.GetContext');
                        sb.emitSysCall(node, 'Neo.Storage.Put');
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'DROP');
                    },
                }));
            },
        }));
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            return;
        }
        sb.emitHelper(node, options, sb.helpers.getGlobalProperty({ property: GlobalProperty.CommonStorage }));
    }
}

//# sourceMappingURL=CommonStorageHelper.js.map
